// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"593":"7b5d23fa","613":"9de08e5d","933":"a20dfb38","944":"3d7ecc56"}[chunkId] + ".chunk.css";
};